import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Projects from '../views/Projects.vue'
import FenixAlliance from '@/views/FenixAlliance.vue'
import NothernSkies from '@/views/NothernSkies.vue'
import PlayingTheGame from '@/views/PlayingTheGame.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/projects',
    name: 'Projects',
    component: Projects
  },
  {
    path: '/fnx',
    name: 'FenixAlliance',
    component: FenixAlliance
  }
  ,
  {
    path: '//northernskies',
    name: 'NorthernSkies',
    component: NothernSkies
  }
  ,
  {
    path: '//playingthegame',
    name: 'PlayingTheGame',
    component: PlayingTheGame
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
